import React from 'react';
import { OrderedMap } from 'immutable';
import classNames from 'classnames/bind';
import { Scrollbar } from '@saucelabs/sl-component-scrollbar';

import { Filter } from './FilterColumn';
import Styles from './FilterListCheckbox.styles';

const context = classNames.bind(Styles);

export type FilterListCheckboxProps = {
  filterCategory: string;
  filters: OrderedMap<string, Filter>;
  toggleItem: (key: string) => void;
};

const fallbackFilter: Filter = {
  active: true,
  disabled: false,
  greyedOut: false,
  label: '',
};

const FilterListCheckbox: React.FC<FilterListCheckboxProps> = ({
  filterCategory,
  filters,
  toggleItem,
}) => (
  <div className={`${Styles.default} border border-solid border-gray-200`}>
    <Scrollbar noScrollX>
      <ul className="list-none m-0 p-0">
        {/*
          // might look odd but since immutable 3.x types are crap
          // and don't really support the types in their data structures
          // we need to provide that fallback because TS assumes
          // filter could be undefined (which is never true)
        */}
        {filters.map(((filter = fallbackFilter, key) => {
          const uniqueKey = `${filterCategory}-${key as string}`;
          const { active, disabled, greyedOut, label } = filter;

          return (
            <li
              key={uniqueKey}
              aria-label={uniqueKey}
              className={context('filter-item', {
                'hover:bg-gray-50': !disabled,
                'cursor-default': disabled,
              })}
            >
              <label
                className={context('text-gray-600', {
                  'text-gray-disabled': greyedOut,
                })}
                htmlFor={uniqueKey}
              >
                {label || key}
                <input
                  checked={active}
                  className={Styles.input}
                  disabled={disabled}
                  id={uniqueKey}
                  onChange={() => toggleItem(key as string)}
                  type="checkbox"
                />
              </label>
            </li>
          );
        })).toArray()}
      </ul>
    </Scrollbar>
  </div>
);

export default FilterListCheckbox;
